module.exports = __webpack_public_path__ + "img/Aaron_O_23.05b4a1a0.jpg";